export default __webpack_public_path__ + "static/media/쉐어플러그_01.5cc94929.svg";